
import React from "react";
import { useTranslation } from "react-i18next";

export default function BlankInbox() {
    const { t } = useTranslation();
    return (<>
        
        <div className="empty-state no-selection text-center">
            <img src={'/assets/img/inbox.svg'}/>
            <h2 className="font-accent">{t("blankInbox.select_conversation")}</h2>
            <small>{t("blankInbox.select_conversation_hint")}</small>
            </div>
        
    </>)
}
